import { FC } from 'react';
import { MaskVariant } from '../../enums';
import { Mask } from '../mask';
import { Props } from './types';
import css from './style.module.css';

export const Entry: FC<Props> = ({ uniqueId, place, size, children }) => {
  const offset = place === 0 ? undefined : -(size / 4);

  const maskId = `AvatarStack${uniqueId}${place}${size}`;
  const maskVariant = place === 0 ? MaskVariant.DEFAULT : MaskVariant.LEFT;

  return (
    <div
      className={css.root}
      style={{
        marginLeft: offset,
      }}
    >
      <Mask id={maskId} size={size} variant={maskVariant} />

      <div style={{ clipPath: `url(#${maskId})` }}>{children}</div>
    </div>
  );
};
